import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultCrmUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultCrmUsers');

export const accountSearchResultCrmUsersActions = accountSearchResultCrmUsersSlice.actions;

const accountSearchResultCrmUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.accountSearchResult.crmUsers.cache;
export const accountSearchResultCrmUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.accountSearchResult.crmUsers;
export const accountSearchResultCrmUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultCrmUsersCacheSelector,
    accountSearchResultStateSelector,
);
